import { render, staticRenderFns } from "./TasksLift.vue?vue&type=template&id=15fc0bbe&scoped=true"
import script from "./TasksLift.vue?vue&type=script&lang=js"
export * from "./TasksLift.vue?vue&type=script&lang=js"
import style0 from "./TasksLift.vue?vue&type=style&index=0&id=15fc0bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc0bbe",
  null
  
)

export default component.exports